/**
 * Same behaviour as HTML title attribute but it shows right away and on touch events too
 */
import Vue from 'vue';
import $ from 'jquery';

Vue.directive('quick-title', {
  bind(el, binding) {
    el.vQuickTitleNoText = !binding.value || binding.value == '';
    $(el).addClass('quick-title-hoverable');
    el.vQuickTitle = $.parseHTML(`<div class="quick-title">${binding.value}</div>`)[0];
    $(document.body).append(el.vQuickTitle);
    const timeEventThreshold = 600; // ms
    let touchEventTime = null; // Time of touchstart event
    el.quickTitleHover = (e) => {
      if (el.vQuickTitleNoText) {
        return;
      }
      const coord = e.touches && e.touches.length ? e.touches[0] : e;
      const { pageY } = coord;
      el.vQuickTitle.style.transform = pageY < 50
        ? 'translateY(1em)'
        : 'translateY(-100%) translateY(-1em)';
      el.vQuickTitle.style.top = `${coord.pageY}px`;
      if (e.type == 'mouseenter' || e.type == 'touchstart') {
        if (e.type == 'touchstart') {
          touchEventTime = new Date();
        } else if (
          touchEventTime != null
          && new Date().getTime() - touchEventTime.getTime() < timeEventThreshold
        ) {
          // When clicking on the element, mouseenter is triggered right after touchstart
          return;
        }
        el.vQuickTitle.style.display = 'block';
      }
      const width = el.vQuickTitle.offsetWidth;
      const left = coord.pageX - width / 2;
      el.vQuickTitle.style.left = `${left < 0 ? 0 : left}px`;
    };
    el.quickTitleHoverOut = (e) => {
      el.vQuickTitle.style.display = 'none';
    };
    el.addEventListener('touchstart', el.quickTitleHover);
    el.addEventListener('mouseenter', el.quickTitleHover);
    el.addEventListener('mousemove', el.quickTitleHover);
    el.addEventListener('touchend', el.quickTitleHoverOut);
    el.addEventListener('touchcancel', el.quickTitleHoverOut);
    el.addEventListener('mouseleave', el.quickTitleHoverOut);
  },
  unbind(el) {
    el.removeEventListener('touchstart', el.quickTitleHover);
    el.removeEventListener('mouseenter', el.quickTitleHover);
    el.removeEventListener('mousemove', el.quickTitleHover);
    el.removeEventListener('touchend', el.quickTitleHoverOut);
    el.removeEventListener('touchcancel', el.quickTitleHoverOut);
    el.removeEventListener('mouseleave', el.quickTitleHoverOut);
    if (el.vQuickTitle) {
      el.vQuickTitle.remove();
    }
    el.quickTitleHover = null;
    el.quickTitleHoverOut = null;
    el.vQuickTitle = null;
  },
  update(el, binding) {
    if (el.vQuickTitle) {
      const $el = $(el);
      if (!$el.hasClass('quick-title-hoverable')) {
        $el.addClass('quick-title-hoverable');
      }
      el.vQuickTitle.innerHTML = binding.value;
      el.vQuickTitleNoText = !binding.value || binding.value == '';
    }
  },
});
